import moment from 'moment';
import React from 'react';



export const renderAuthorizePartners = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);
}

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox"
                    onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            
            {headers[6].value && <td>{headers[6].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

//formato de cantidades

const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";
    body = data.map((businessPartner, index) => {
        const partnerObject = JSON.parse(businessPartner.body);

        return (
            <tr key={index}>
                <td className="sticky-column" onClick={() => checkbox.selectOne(index)} >
                    <input
                        type="checkbox"
                        style={{ minWidth: '100%' }} id="cbox2"
                        checked={!!checkbox.data.get(index)} />
                </td>

                {headers[0].value && <td>{index ?? ''}</td>}
                {headers[1].value &&
                    <td>
                        {businessPartner.status === 'W' ? 'Pendiente' : businessPartner.status === 'Y' ? 'Autorizado' : 'Rechazado'}
                    </td>
                }
                {headers[7].value && <td>{businessPartner.comments ?? ''}</td>}
                {headers[2].value &&
                    <td>{partnerObject ? `${partnerObject.CardCode}` : ''}</td>
                }
                {headers[3].value && <td>{partnerObject ? `${partnerObject.CardName}` : ''}</td>}
                {headers[4].value && <td>{businessPartner.creator ?? ''}</td>}
                {headers[5].value && <td>{moment(businessPartner.createdDate).format('YYYY-MM-DD')} </td>}
                {headers[6].value && <td>{businessPartner.type === 1 ? 'Nuevo socio' : 'Edición de información'}</td>}

                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    {businessPartner.type !== 3 &&
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" /*data-toggle="modal" data-target="#approveBusinessPartnerModal"*/
                            onClick={() => openDetails(businessPartner)}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    }
                </td>
            </tr>
        )
        // }
    })
    return body;
};